import StepTick from "Assets/Img/StepTick";
import Button from "Components/Common/Button/Button";

interface Step {
  id: number;
  label: string;
}

interface StepTabsProps {
  steps: Step[];
  currentStep: number;
  onStepChange?: (stepId: number) => void;
  successMode: boolean;
}

const StepTabs = ({
  steps,
  currentStep,
  onStepChange,
  successMode,
}: StepTabsProps) => {
  const getStepState = (step: Step): "active" | "done" | "pending" => {
    if (successMode) return "done";
    if (step.id === currentStep) return "active";
    if (step.id < currentStep) return "done";
    return "pending";
  };

  return (
    <nav className="stepTabs" aria-label="Draw request steps">
      {steps.map((step) => {
        const state = getStepState(step);
        const isCurrent = state === "active";
        const isDone = state === "done";

        return (
          <Button
            key={step.id}
            className={`stepTab ${state !== "pending" ? state : ""}`.trim()}
            onClick={() => onStepChange?.(step.id)}
            type="button"
            aria-current={isCurrent ? "step" : undefined}
            aria-label={`Step ${step.id}: ${step.label}`}
            disabled={successMode}
          >
            <span className="stepNum" aria-hidden="true">
              {isDone ? <StepTick /> : step.id}
            </span>
            <span className="stepName">{step.label}</span>
          </Button>
        );
      })}
    </nav>
  );
};

export default StepTabs;
